import * as React from 'react';
import injectSheet from 'react-jss';
import { Line } from 'react-chartjs-2';
import Chartify from '@shipsy/chartify';
// import { Sparklines, SparklinesLine, SparklinesSpots } from 'react-sparklines';
import * as numeral from 'numeral';

const styles = (theme: any) => ({

  number: {
    fontSize: '10em',
    fontWeight: 700,
    background: '#fff',
    textAlign: 'center',
  },
});

const options = {
  maintainAspectRatio: false,
  layout: {
    padding: 20,
  },
  tooltips: {
    mode: 'label',
    intersect: true,
    titleFontSize: 10,
    footerFontSize: 10,
    caretSize: 0,
    position: 'nearest',
    bodyFontSize: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  hover: {
    mode: 'nearest',
    intersect: true,
  },
  responsive: true,
  legend: {
    display: false,
  },
  scales: {
    xAxes: [{
      display: false,
    }],
    yAxes: [{
      display: false,
    }],
  },
  // elements: { point: { hitRadius: 2, hoverRadius: 2, radius: 2 } },
  fill: false,
};
class BigNumberWithTrendLines extends React.PureComponent<any, any> {
  render() {
    const { formData, theme, classes, chartData, width, height } = this.props;
    const chartifyInstance = new Chartify.LineData(chartData.trends, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();
    return (<div>
      <div  className={classes.number} style={{ color: (
        chartData.number
        && Number(chartData.number.toString()) < 0) ?
          theme.errorColor : '#262626',
        fontSize: `${width / 10}px`,
      }}>
          {(chartData.number) ?
          numeral(Number(chartData.number.toString()))
            .format('(0,0.0 a)').toUpperCase() : 'No Data'}
      </div>
      {formData.show_trend_line ? (
        <div style={{ height: 80 }}>
          <Line data={chartifyData.data.lineChartData} options={options} />
        </div>
      ) : ''}
    </div>);
  }
}

const BigNumberWithTrendLinesStyled = injectSheet(styles)(BigNumberWithTrendLines);
export default BigNumberWithTrendLinesStyled;
